import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
export function Guarantee() {
  return <Section tone="white" data-id="element-117" data-mp="1o2vi2rco2r7m">
      <div className="mx-auto max-w-[680px] rounded-card border border-gold-line bg-ivory p-8 text-center sm:p-12" data-id="element-118" data-mp="1o5pzsb4apxxc">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-gold bg-white" aria-hidden="true" data-id="element-119" data-mp="1x4browvnqpas">
          <ShieldCheckIcon className="h-7 w-7 text-gold" data-id="element-120" data-mp="19f0nt6j0gesf" />
        </span>

        <h2 className="mt-7 font-serif text-[26px] leading-tight sm:text-[34px]" data-id="element-121" data-mp="14gpcssgzby8m">
          Garantía de 7 días, sin preguntas
        </h2>

        <p className="mt-5 font-serif text-lg italic text-gold-dark sm:text-xl" data-id="element-122" data-mp="1j6n7lr9ezm6s">
          Descárgalo. Abre los seis tomos. Úsalo con una clienta real.
        </p>

        <p className="measure mx-auto mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-123" data-mp="qmyekg8p80s7">
          Si en 7 días no es lo que esperabas, te devolvemos el 100% — sin
          formularios, sin vueltas y sin resentimientos.
        </p>
      </div>
    </Section>;
}